import { render, staticRenderFns } from "./SpinningWheel.vue?vue&type=template&id=384b1100&scoped=true&"
import script from "./SpinningWheel.vue?vue&type=script&lang=js&"
export * from "./SpinningWheel.vue?vue&type=script&lang=js&"
import style0 from "./SpinningWheel.vue?vue&type=style&index=0&id=384b1100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384b1100",
  null
  
)

export default component.exports